/**
 * to add commas to price
 * @param {number} value
 * @param {string} currency
 * @param {boolean} prefixCurrencyName - show currency name where it is otherwise ambiguous (e.g. Australian and USA
 *   dollars, since they both use the same dollar symbol, but for euros there's no ambiguity)
 * @returns string
 */
export const formatCurrency = (value, currency, prefixCurrencyName = false) => {

    if (!currency) {
        return "No currency available";
    }

    let roundedFloat;
    try {
        roundedFloat = parseFloat(value.toFixed(2));
    } catch {
        console.log(value, currency);
        return `${currency} ${value}`;
    }

    let prefix = "";
    if (prefixCurrencyName && currency.toUpperCase() !== "EUR") {
        prefix = `${currency.toUpperCase()} `;
    }
    return prefix + roundedFloat.toLocaleString("en-US", {
        style: "currency",
        currency: currency,
        currencyDisplay: "narrowSymbol" // Prints "$" rather than "A$" or "US$" (we add our own custom qualifier)
    });
};
